import { Loader2, AlertCircle } from "lucide-react";

export function LoadingBlock({ label }: { label: string }) {
  return (
    <div className="nx-card p-8 flex items-center justify-center gap-2 text-sm text-fg-subtle">
      <Loader2 size={14} className="animate-spin" />
      {label}
    </div>
  );
}

export function ErrorBlock({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="nx-card p-6 flex flex-col items-center text-center gap-2">
      <AlertCircle size={18} className="text-danger" />
      <p className="text-sm text-fg-muted">
        No pudimos cargar este bloque. El backend puede estar desplegándose.
      </p>
      <button onClick={onRetry} className="nx-btn-secondary mt-2">
        Reintentar
      </button>
    </div>
  );
}

export function EmptyBlock({ label }: { label: string }) {
  return (
    <div className="text-sm text-fg-subtle py-4 text-center">{label}</div>
  );
}
